{
  "lifetools.sum": "Sum",
  "lifetools.average": "Average",
  "lifetools.ratio": "Ratio",
  "lifetools.parameters": "Parameters and targets",
  "lifetools.metric_count_one": "1 metric",
  "lifetools.metric_count_other": "{{count}} metrics",
  "lifetools.rule_count_one": "1 rule",
  "lifetools.rule_count_other": "{{count}} rules",
  "lifetools.inbox_count_one": "1 notification",
  "lifetools.inbox_count_other": "{{count}} notifications",
  "lifetools.refresh": "Refresh",
  "lifetools.unknown_status": "Status unavailable",
  "lifetools.inbox_filters": "Notification filters",
  "lifetools.inbox_select_all": "Select visible unread notifications",
  "lifetools.inbox_select_notification": "Select notification {{title}}",
  "lifetools.inbox_selected_one": "1 notification selected",
  "lifetools.inbox_selected_other": "{{count}} notifications selected",
  "lifetools.inbox_mark_selected_read": "Mark selected as read",
  "lifetools.inbox_mark_notification_read": "Mark {{title}} as read",
  "lifetools.inbox_bulk_read_error": "The selected notifications could not be marked as read. Try again.",
  "lifetools.proactive_observations.title": "Standing observations",
  "lifetools.proactive_observations.description": "Opt in to fact-based checks. A finding creates a reviewable proposal; it never changes your work automatically.",
  "lifetools.proactive_observations.load_error": "Standing observations could not be loaded",
  "lifetools.proactive_observations.action_error": "That observation could not be updated. Try again.",
  "lifetools.proactive_observations.unscheduled_commitment.title": "Unscheduled commitments",
  "lifetools.proactive_observations.unscheduled_commitment.description": "Notice open tasks that have no calendar block.",
  "lifetools.proactive_observations.project_without_next_action.title": "Projects without a next action",
  "lifetools.proactive_observations.project_without_next_action.description": "Notice active projects without an explicitly selected next-action task.",
  "lifetools.proactive_observations.routine_slipped_three_times.title": "Routines that slipped three times",
  "lifetools.proactive_observations.routine_slipped_three_times.description": "Notice when the latest three due occurrences remain open or skipped.",
  "lifetools.proactive_observations.period_ending_with_open_work.title": "Periods ending with open work",
  "lifetools.proactive_observations.period_ending_with_open_work.description": "Notice periods ending within seven days while member work is still open.",
  "lifetools.proactive_observations.week_without_rest_block.title": "Weeks without a rest block",
  "lifetools.proactive_observations.week_without_rest_block.description": "Notice a calendar week with no active protected rest window."
}
